import { render, staticRenderFns } from "./IntegrationsVacancyListEmpty.vue?vue&type=template&id=6760593b&scoped=true&"
import script from "./IntegrationsVacancyListEmpty.vue?vue&type=script&lang=js&"
export * from "./IntegrationsVacancyListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsVacancyListEmpty.vue?vue&type=style&index=0&id=6760593b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760593b",
  null
  
)

/* custom blocks */
import block0 from "./IntegrationsVacancyListEmpty.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=en"
if (typeof block0 === 'function') block0(component)
import block1 from "./IntegrationsVacancyListEmpty.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=ru"
if (typeof block1 === 'function') block1(component)

export default component.exports